import React from 'react';

const RefundPolicy: React.FC = () => {
    return (
        <div className="pt-24 pb-20 bg-dark-900">
            <div className="container px-4 mx-auto">
                <div className="mx-auto max-w-4xl">
                    <h1 className="mb-8 text-4xl font-bold text-white">Refund Policy</h1>

                    <div className="prose prose-invert">
                        <p className="mb-6 text-dark-300">Last updated: 30/04/2025</p>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">14-Day Money-Back Guarantee</h2>
                            <p className="mb-4 text-dark-300">
                                We offer a 14-day money-back guarantee on all purchases. If you're not satisfied with
                                WinMax Optimizer, you can request a full refund within 14 days of your purchase.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">Refund Eligibility</h2>
                            <p className="mb-4 text-dark-300">
                                To be eligible for a refund:
                            </p>
                            <ul className="pl-6 mb-6 list-disc text-dark-300">
                                <li>The request must be made within 14 days of purchase</li>
                                <li>Your license key will be deactivated upon refund</li>
                                <li>You must provide a reason for the refund request</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">How to Request a Refund</h2>
                            <p className="mb-4 text-dark-300">
                                To request a refund:
                            </p>
                            <ol className="pl-6 mb-6 list-decimal text-dark-300">
                                <li>Log into your account at{' '}
                                    <a
                                        href="https://licensing.winmaxoptimizer.com"
                                        className="text-primary-400 hover:text-primary-300"
                                    >
                                        licensing.winmaxoptimizer.com
                                    </a>
                                </li>
                                <li>Navigate to your purchases</li>
                                <li>Click the "Request Refund" button</li>
                                <li>Fill out the refund request form</li>
                            </ol>
                        </section>

                        <section>
                            <h2 className="mb-4 text-2xl font-semibold text-white">Contact Us</h2>
                            <p className="text-dark-300">
                                If you have any questions about our refund policy, please contact us at{' '}
                                <a href="mailto:support@winmaxoptimizer.com" className="text-primary-400 hover:text-primary-300">
                                    support@winmaxoptimizer.com
                                </a>
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;